module.exports = __webpack_public_path__ + "static/media/1.19.bf36f19a.png";